import { createAction, COPY2PAYLOAD, SILENT } from 'uix/actions';
// track availability of server api
export const setHTTPState = createAction('SET_HTTP_STATE', COPY2PAYLOAD, SILENT);
export const setNetworkInfo = createAction('SET_NETWORK_INFO', COPY2PAYLOAD);
export const setOnline = createAction('SET_ONLINE', (online)=>online);
// only exposed as action for server-side-testing
export const runNetCheck = createAction('RUN_NET_CHECK', COPY2PAYLOAD, SILENT);
export const setWebsocketState = createAction('SET_WEBSOCKET_STATE', COPY2PAYLOAD, SILENT);
export const subscribeServerEvent = createAction('SUBSCRIBE_SERVER_EVENT', (eventName, active)=>({
        eventName,
        active
    }));
